import { render, staticRenderFns } from "./IcoCubeCheck.vue?vue&type=template&id=6d65979e"
import script from "./IcoCubeCheck.vue?vue&type=script&lang=js"
export * from "./IcoCubeCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports